import { AdTag } from "@fresh8/types";
import properties from "./properties";
// import Mock from "../mocks/mock-ww-payload.json";

function queryStringBuilder(dict: Partial<{ [name: string]: string }>) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(dict)) {
    if (value) {
      params.append(key, value as string);
    }
  }

  return params.toString();
}

declare global {
  interface Window {
    adtagData?: AdTag;
    adtagId?: string;
  }
}

export async function getAdtag(id: string | null, useMockBrand?: string) {
  if (useMockBrand) {
    // return import("../mocks/mock-brand.json").then(data => ({ ...data }));
  }

  if (window.adtagData) {
    return window.adtagData;
  }

  const headers = new Headers({
    ["Accept"]: "application/json"
  });

  const response = await fetch(`https://${properties.adtagCdnUri}/json/${id}`, {
    method: "GET",
    mode: "cors", // no-cors, *cors, same-origin
    cache: "default",
    headers
  });

  return response.json();
}

export async function getBet(
  id?: string,
  ref?: string,
  clickUrl?: string,
  targetUrl?: string,
  useMockData?: string,
  rest?: { [x: string]: string | undefined }
) {
  id = window.adtagId || id;
  if (useMockData) {
    // return import("../mocks/mock-payload-parlay.json");
  }
  const headers = new Headers({
    ["Accept"]: "application/json"
  });

  // return Mock;

  const queryParams =
    typeof ref === "string" ||
    typeof clickUrl === "string" ||
    typeof targetUrl === "string" ||
    (rest && Object.keys(rest).length > 0)
      ? queryStringBuilder({
          ref,
          clickUrl,
          targetUrl,
          ...rest
        })
      : undefined;

  const response = await fetch(
    `https://${properties.dataApiUri}/${id}/adtag.js?${
      queryParams ? queryParams : ""
    }`,
    {
      method: "GET",
      mode: "cors", // no-cors, *cors, same-origin
      cache: "default",
      headers
    }
  );

  return response.json();
}

export async function getJSON(url: string) {
  const headers = new Headers({
    ["Accept"]: "application/json"
  });

  const response = await fetch(url, {
    method: "GET",
    mode: "cors", // no-cors, *cors, same-origin
    cache: "default",
    headers
  });

  return response.json();
}

export async function getPreview(previewOptions: {
  operator: string | undefined;
  sport: string | undefined;
  eventId: string | undefined;
  competitors: string | undefined;
  competitions: string | undefined;
  marketIds: string | undefined;
  marketTypes: string | undefined;
  limit: string | undefined;
}) {
  const headers = new Headers({
    ["Accept"]: "application/json"
  });

  const queryParams = queryStringBuilder(previewOptions);

  const response = await fetch(
    `https://${properties.previewApiUri}?${queryParams}`,
    {
      method: "GET",
      mode: "cors", // no-cors, *cors, same-origin
      cache: "default",
      headers
    }
  );

  return response.json();
}
